import {
  disconnectZoomApiCall,
  generateZoomMeetingApiCall,
  getLatestZoomMeetingUrlApiCall,
  getZoomUserApiCall,
  zoomCheckIfProviderConnectedApiCall,
} from '@guryou/api-client-gql';

import { resetState } from '../actions';
import { execute } from '../actions/actionWrapper';
import { Action, basicReducer } from '../core';

export const ZOOM_CHECK_IF_CONNECTED = { entity: 'ZOOM_CHECK_IF_CONNECTED', action: Action.GET_ONE };
export const ZOOM_DISCONNECT = { entity: 'ZOOM_DISCONNECT', action: Action.UPDATE };
export const ZOOM_GENERATE = { entity: 'ZOOM_GENERATE', action: Action.GET };

export const GET_ZOOM_USER = { entity: 'GET_ZOOM_USER', action: Action.GET };
export const GET_LATEST_ZOOM_MEETING = { entity: 'GET_LATEST_ZOOM_MEETING', action: Action.GET };

export const zoomCheckIfConnected = () => async dispatch =>
  execute(dispatch, () => zoomCheckIfProviderConnectedApiCall(), ZOOM_CHECK_IF_CONNECTED, false);

export const generateZoom = () => async dispatch => execute(dispatch, () => generateZoomMeetingApiCall(), ZOOM_GENERATE, false);

export const disconnectZoom = () => async dispatch => execute(dispatch, () => disconnectZoomApiCall(), ZOOM_DISCONNECT, false);

export const resetZoomCheck = () => async dispatch => dispatch(resetState(ZOOM_CHECK_IF_CONNECTED));

export const getZoomUser = () => async dispatch => execute(dispatch, () => getZoomUserApiCall(), GET_ZOOM_USER, false);

export const getLatestZoomMeeting = () => async dispatch => execute(dispatch, () => getLatestZoomMeetingUrlApiCall(), GET_LATEST_ZOOM_MEETING, false);

export const zoomReducers = {
  isConnected: basicReducer(ZOOM_CHECK_IF_CONNECTED),
  generate: basicReducer(ZOOM_GENERATE),
  disconnect: basicReducer(ZOOM_DISCONNECT),
  zoomUser: basicReducer(GET_ZOOM_USER),
  latestZoomMeeting: basicReducer(GET_LATEST_ZOOM_MEETING),
};
